/* global globalThis */
import Vue from 'vue'

import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import AppTranslateAI from './AppTranslateAI.vue'

Vue.prototype.$ansPublicTranslatorAi = globalThis.ansPublicTranslatorAi

// Le script est chargé sur toutes les pages WordPress : on ne monte l'app
// que si la div cible est réellement présente, sinon Vue la monterait
// quand même sur un div détaché et déclencherait les appels API inutilement.
const mountEl = document.getElementById('app-translate-ai')

if (mountEl) {
  new Vue({
    vuetify,
    render: (h) => h(AppTranslateAI)
  }).$mount(mountEl)
}